import * as types from './mutations-types'; // mutations.js
import { defaultState } from './state';

const resetState_ = state => {
	Object.assign(state, defaultState);
};
const defaultSelect = (state, { optionNm, valueNm }) => {
	state[valueNm] = state[optionNm][0]['value'];
};

const changeValue = (state, data) => {
	// console.log('changeValue', data);
	state[`${data.name}`] = data.value;
	// console.log('changeValue', data);
};

const selectDate = (state, { from, to }) => {
	// console.log('mutation-selectDate', from, to);
	state.fromDate = from;
	state.toDate = to;
	// console.log('mutation-selectedDate', state.fromDate, state.toDate);
};

export default {
	[types.DEFAULT_ASSIGN]: (state, payload) => {
		state[payload.key] = payload.value;
	},
	defaultSelect,
	changeValue,
	selectDate,
	resetState_
};
